import type { SVGProps } from 'react';

import { unitMapping, type Unit } from '#src/lib/style.ts';
import type { Color } from '#src/style/types.ts';

type Props = { size?: Unit; color?: Color };

export const Packs = ({
  size = 2,
  color = 'currentColor',
  ...props
}: Omit<SVGProps<SVGSVGElement>, 'color'> & Props) => {
  return (
    <svg
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      viewBox="0 0 17.5303 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.1964 14.5615C13.1964 14.5819 13.2009 14.602 13.2098 14.62L13.799 15.817C13.8399 15.9 13.7842 16 13.6971 16H3.2C3.11292 16 3.05721 15.9 3.09806 15.817L3.68728 14.62C3.69613 14.602 3.70081 14.5819 3.70081 14.5615V14.515H13.1964V14.5615ZM13.1964 13.6453H3.70081V2.37599H13.1964V13.6453ZM13.7088 0C13.793 0 13.8489 0.0942647 13.8137 0.176842L13.2458 1.50626H3.65131L3.0834 0.176842C3.04813 0.0942714 3.10403 1.51382e-05 3.18827 0H13.7088Z"
        fill={color}
      />
      <path
        d="M2.62842 13.5883H0.0877958C0.0278203 13.5882 -0.0106603 13.5189 0.0174833 13.4617L0.423733 12.6367C0.429735 12.6244 0.433064 12.6108 0.433108 12.5969V12.5648H2.62842V13.5883ZM17.0979 12.5969C17.098 12.6107 17.1006 12.6245 17.1065 12.6367L17.5128 13.4617C17.5408 13.5188 17.5023 13.5881 17.4425 13.5883H14.28V12.5648H17.0979V12.5969ZM2.62842 11.9648H0.433108V4.19609H2.62842V11.9648ZM17.0979 11.9648H14.28V4.19609H17.0979V11.9648ZM2.62842 3.59609H0.398733L0.0073271 2.67969C-0.0169006 2.62279 0.0219415 2.55782 0.0799833 2.55781H2.62842V3.59609ZM17.4511 2.55781C17.5089 2.55816 17.5471 2.62293 17.5229 2.67969L17.1315 3.59609H14.28V2.55781H17.4511Z"
        fill={color}
      />
    </svg>
  );
};
